import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { Component, OnInit, Input, AfterViewInit, QueryList, ViewChild } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import * as moment from 'moment/moment';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { QueryByStatusDTO } from 'src/app/models/internal/query-bystatus-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserData } from '../../../models/auth/userdata';
import { SelectedAutocompleteValue } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.model';
import { SourceType } from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { ProposalExternalComment } from 'src/app/models/proposal-external-comment';
import { QueryExternalCommentUnReadDTO } from 'src/app/models/internal/query-external-comment-unread-dto';
import { QueryUpdateExternalCommentReadStatusDTO } from 'src/app/models/internal/query-external-comment-update-read-status-dto copy';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-unreadcommentslist',
    templateUrl: './unreadcommentslist.component.html',
    styleUrls: ['./unreadcommentslist.component.scss'],
})
export class UnreadcommentslistComponent extends BaseGridPage implements OnInit, AfterViewInit {
    unReadcommentsList: ProposalExternalComment[];
    allItemsCheckBoxSelected: boolean = false;
    updateProposalStatusDTO = new UpdateProposalStatusDTO();
    filterForm: FormGroup;

    constructor(
        private appGlobalDataService: AppGlobalDataService,
        private dataService: DataService,
        private proposalService: ProposalService,
        localstorageService: LocalstorageService,
        private router: Router,
        private fb: FormBuilder,
        private toastService: ToastService,
        logger: NGXLogger,
        appSettings: AppSettings,
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            PartNumber: [null],
            PartDescription: [null],
            SupplierCode: [null],
            IsTeslaCreated: [null],
            EffectiveFrom: [null],
            CreatedOn: [null],
            EngineerUserId: [null],
            SourceTypeId: [null],
            PartCategoryId: [null],
            IsTeslaUpdated: [false]
        });
    }

    ngOnInit() {
            this.initFilterValues();
            this.fillGrid();
    }
    initFilterValues(): void {
        this.filter = new SearchFilter();
    }
    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        this.getUnreadProposalExternalComments();
    }
    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
    }
    clearFilter() {
        this.filterForm.reset();
        this.filterForm.controls['IsTeslaUpdated'].setValue(false);
        this.filter.SearchFilterConditions = [];
        this.search();
    }

    onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
        if (isSelected) {
            this.unReadcommentsList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = true;
            if (
                this.unReadcommentsList.filter(a => a.IsSelected === true)
                    .length === this.unReadcommentsList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
        } else {
            this.unReadcommentsList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
    }

    setAllSelected(isSelected: boolean) {
        // this.partinfoList.map(function(part) {
        //     part.IsSelected = isSelected;
        //     return part;
        // });
        this.unReadcommentsList.forEach(part => {
            part.IsSelected = isSelected;
        });
    }

    getAllSelectedOrNot(getSelected: boolean): number[] {
        return this.unReadcommentsList
            .filter(a => a.IsSelected === getSelected)
            .map(prop => prop.Id);
    }

    ValidateForm() {
    }

    getUnreadProposalExternalComments() {
      const queryExternalCommentUnReadDTO: QueryExternalCommentUnReadDTO = new QueryExternalCommentUnReadDTO();
      queryExternalCommentUnReadDTO.SearchFilter = this.filter;
      this.dataService.getUnreadProposalExternalComments(queryExternalCommentUnReadDTO).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.unReadcommentsList = response.Data;
                this.gridView = of({
                    data: response.Data,
                    total: response.Total ? response.Total : 0,
                });
                this.appGlobalDataService.RefreshUnreadMessageCount(response.Total);
            }
        });
      }

      MarkCommentAsRead(id: number) {
        const queryUpdateExternalCommentReadStatusDTO: QueryUpdateExternalCommentReadStatusDTO = new QueryUpdateExternalCommentReadStatusDTO();
        const ids: number[] = [];
        ids.push(id);
        queryUpdateExternalCommentReadStatusDTO.Ids = ids;
        queryUpdateExternalCommentReadStatusDTO.IsRead = true;
        this.dataService.updateUpdateReadStatusProposalExternalComment(queryUpdateExternalCommentReadStatusDTO).subscribe((response: any) => {
            if (response != null) {
                this.logDebug('updated read status= ' + response);
            }
            this.fillGrid();
        });
      }

      viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('viewproposal/' + id, '_blank');
      }

}

